import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import ChartsContent from "./ChartsContent";
import PatientChartsService from "../../../../../services/PatientChartsService";
import {isArray, isObject, isSet} from "../../../../../utils/commonUtils";
import WithRoutify from "../../../../../hoc/WithRoutify";
import OrganizationService from "../../../../../services/OrganizationService";
import FileManagerService from "../../../../../services/FileManagerService";
import Alert from "../../../../../components/UI/ConfirmBox/Alert";
import { createPortal } from "react-dom";
import { acl_check } from "../../../../../utils/aclUtils";
import PERMISSIONS from "../../../../../utils/AclPermissions";
import withReduxState from "../../../../../hoc/wReduxState";
import { connect } from "react-redux";
import { activeProfileDetails } from "../../../../../store/SessionSlice";
import AuthService from "../../../../../services/AuthService";
import FormCompletion from "../../../../PatientFormContainer/Forms/FormCompletion";
class ActivityCharts extends Component {
    constructor(props) {
        super(props);
        this.state ={
            showAlert:false,
            formData:{},
            status:1000,
            hasEditAccess:true,
            validation:{},
            profileDetails:{},
            childLab:[], // State for child lab orders (for new entries)
            showIncompleteExamModal: false,
            incompleteExamErrorsBySection: null,
            pendingValidation: null,
        }
        // Add constructor if you need to initialize state or bind methods
    }

    onChangeHandler =(key,val,obj={})=>{
        const updateValidation={...this.state.validation};
        updateValidation[key]='';
        if(key==='collection_type'){
            updateValidation['collection_remarks']=''
        }
        this.setState((oldState) => ({
            formData: {
                ...oldState.formData,
                [key]: val,
                ...obj
            },
            validation:{...updateValidation}
        }));
    }
    updateFormData =(obj={})=>{

        const keysToEmptyString = ['new_adulteration_signs', 'other_reason', 'suggested_status'];

        // Map over the keys in obj and set their values to ""
        const validation = {};
        keysToEmptyString.forEach(key => {
            if (obj.hasOwnProperty(key)) {
                validation[key] = "";
            }
        });
        
        this.setState((oldState) => ({
            formData: {
                ...oldState.formData,
                ...obj
            },
            validation:{...validation}
        }));
    }
    setChildLab = (childLab) => {
        this.setState({ childLab });
    }
    setFormData = (obj={})=>{
        this.setState({formData:obj,status:200});
    }
    componentDidMount = () => {
      this.fetchPatientChartDetials();
      
      // Calculate the access level first
      let hasEditAccess = acl_check(this.props.profile.permissions, [PERMISSIONS.RESULT.EDIT,PERMISSIONS.VISITS.EDIT]);
      // Patient packet / kiosk questionnaire: staff may be logged in but UI must match patient portal
      if (this.props.suppressPatientPostSaveLogout) {
        hasEditAccess = false;
      }
      this.setState({hasEditAccess:hasEditAccess});

      // Check the variable directly to determine if back navigation should be blocked
      if (!hasEditAccess) {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = () => {
          window.history.go(1);
        };
      }
    }
  
    closeHandler=()=>{
        const{hasEditAccess}=this.state;
        if (!hasEditAccess) {
            this.props.toogleHanlder();
            return;
        }
        this.setState({
            showAlert:!this.state.showAlert
        });
    }
  
    render() {
        const { chartDetails } = this.props;
        const {formData,status,hasEditAccess} = this.state;
        const { activity_name, activity_type,required_authority } = chartDetails;
        return (
          <>
          <ChartsContent
            type={activity_type}
            activityId={chartDetails.actitivity_id}
            mappingId={chartDetails.mapping_id}
            activityName={activity_name}
            emrFieldLabel={chartDetails.emr_field_label}
            formData={formData}
            status={status}
            employeeDetails={this.props.employeeDetails}
            companyDetails={this.props.companyDetails}
            lookupsOptions={this.props.lookupsOptions}
            stateList={this.props.stateList}
            toogleHanlder={this.closeHandler}
            visitDetails={this.props.visitDetails}
            changeHandler={this.onChangeHandler}
            setFormData={this.setFormData}
            updateFormData={this.updateFormData} 
            validation={this.state.validation}
            printLabelHandler={this.printLabelHandler}
            printResultHandler={this.printResultHandler}
            onSendLabResults={this.sendLabResultsHandler}
            onSubmitHandler={this.onSubmitHandler}
            onSaveAndSubmitSuccess={() => this.props.toogleHanlder()}
            hasEditAccess={hasEditAccess}
            fetchPatientChartDetials={this.fetchPatientChartDetials}
            setChildLab={this.setChildLab}
            childLab={this.state.childLab}
            employeeId={this.props.employeeId}
            fetchEmployeeDetails={this.props.fetchEmployeeDetails}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            required_authority={required_authority}
            profileDetails={this.props.profileDetails}
            suppressPatientPostSaveLogout={this.props.suppressPatientPostSaveLogout}
            visitType={this.props.visitType ? this.props.visitType : ''}
              />
            {this.state.showAlert &&
              createPortal(
                <Alert
                  onDelete={this.props.toogleHanlder}
                  onSaveAndClose={() => {
                    const isDotProviderExam =
                      (chartDetails?.activity_name === "Examination - DOT" ||
                        chartDetails?.activity_name === "Exam - DOT - Department Of Transportation") &&
                      chartDetails?.activity_type === "Provider Exam";
                    if (isDotProviderExam) {
                      this.onSubmitHandler(undefined, false, true, false, true, true);
                    } else {
                      this.onSubmitHandler();
                    }
                  }}
                  saveAndClose={true}
                  onClose={this.closeHandler}
                    contentTitle="You have unsaved changes.
Would you like to save before exiting?."
                  content={
                   "Are you sure you want to cancel? This action will not save any of the changes made."
                  }
                  yesButtonName={"Confirm"}
                  noButtonName={"Cancel"}
                  confirmButtonClassName='btn btn-primary'
                  cancelButtonClassName=''
                  type="warning"
                />,
                document.getElementsByClassName("sh_modalBox")[0]
              )}
            <Modal
              show={this.state.showIncompleteExamModal}
              onHide={() => this.setState({ showIncompleteExamModal: false, incompleteExamErrorsBySection: null, pendingValidation: null })}
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Incomplete Exam Data</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <p className="mb-3">Please address the following missing information before submission.</p>
                <ul className="list-unstyled mb-0">
                  {this.state.incompleteExamErrorsBySection &&
                    ['History', 'Screening', 'Exam', 'Certification', 'Submission'].map((section) => {
                      const messages = this.state.incompleteExamErrorsBySection[section];
                      if (!messages || !messages.length) return null;
                      return (
                        <li key={section} className="mb-3">
                          <div>
                            <strong>{section}</strong>
                          </div>
                          <ul className="mb-0 ms-3">
                            {messages.map((msg, i) => (
                              <li
                                key={`${section}-${i}`}
                                style={{ color: 'var(--bs-danger, #dc3545)' }}
                              >
                                {msg}
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    })}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={this.handleReviewAndComplete}>
                  Review & Complete
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
    }
    printLabelHandler = async (label_type,labelName)=>{
        const { chartDetails,params,Loader} = this.props;
        Loader(true);
        const {formData} = this.state;
        const activity_name = chartDetails.activity_name;
        const { mapping_id } = chartDetails;
        
        const queryfilters = {
            activity_name:(activity_name),
            label_type:label_type
        }
        try{
             
            let data = null;
            if(isSet(formData.lab)){

                data = await PatientChartsService.getPrintLabel(isSet(formData.organization,null),queryfilters,formData.id);    
            }else{
                data = await PatientChartsService.getPrintLabel(isSet(formData.organization,null),queryfilters,mapping_id);
            }
            
            const pdfData = {
                file_content:data,
                original_name:`${labelName}`,
                mime_type:'application/pdf'
                
            }
            FileManagerService.printPdf(pdfData);
        }catch(e){
            Loader(false);
        }
        Loader(false);
    }
    printResultHandler = async (type='other',isSaveAndPrint=false)=>{
        const { chartDetails,params,Loader} = this.props;
        Loader(true);
        const {formData}    = this.state;
        if(isSet(formData.id,null)===null && isSaveAndPrint===false){
            this.onSubmitHandler(type,true);
        }
        const activityName  = chartDetails.activity_name;
        const mappingId     = chartDetails.mapping_id;
        const visitId       = params.visitId;
        const labelName     = 'Print Result';
        const queryfilters  = {
            visit_id:visitId,
            activity_name:activityName
        }
        try{
            let data = null;
            if(type==='Provider'){
                data = await PatientChartsService.getProviderResult(isSet(formData.organization,null),queryfilters,mappingId);
            }else if(type==='Patient'){
                data = await PatientChartsService.getPatientResult(isSet(formData.organization,null),queryfilters,mappingId);
            }else if(type=='Lab_Report'){
                data = await PatientChartsService.getLaboratoryReport(isSet(formData.organization,null),queryfilters,formData.id);
            }else if(type=='Lab_Requisition'){
                data = await PatientChartsService.getLabRequisition(isSet(formData.organization,null),queryfilters,formData.id);

            }else{
                data = await PatientChartsService.getPrintResult(isSet(formData.organization,null),queryfilters,mappingId);
            }
            // const data = await PatientChartsService.getPrintResult(isSet(formData.organization,null),queryfilters,mappingId);
            const pdfData = {
                file_content:data,
                original_name:`${labelName}`,
                mime_type:'application/pdf'
                
            }
            FileManagerService.printPdf(pdfData);
        }catch(e){
            Loader(false);
        }
        Loader(false);
    }
    sendLabResultsHandler = async (options) => {
        const { formData } = this.state;
        const { params, Loader, Toast, companyDetails } = this.props;
        const labId = isSet(formData?.id, null);
        if (!labId) {
            Toast?.error?.('No lab selected. Please select a lab order first.');
            return;
        }
        const orgId = isSet(formData?.organization, null) ?? params?.organizationId ?? params?.organizationuuid ?? companyDetails?.organization_uuid ?? companyDetails?.company?.organization_uuid;
        if (!orgId) {
            Toast?.error?.('Organization not found.');
            return;
        }
        Loader?.(true);
        try {
            const result = await PatientChartsService.sendLabResults(orgId, {
                lab_id: labId,
                send_patient: !!options?.sendPatient,
                send_employer: !!options?.sendEmployer,
            });
            Toast?.success?.(result?.message || 'Lab results sent successfully.');
        } catch (e) {
            Toast?.error?.(e?.message || 'Failed to send lab results.');
        } finally {
            Loader?.(false);
        }
    }
    focusFirstErrorField = (validation) => {
        // Wait for DOM to update after state change
        setTimeout(() => {
            let errorKeys = Object.keys(validation).filter(key => validation[key] !== "" && validation[key] !== null);
            if (errorKeys.length === 0) return;

            const historyFields = ['driver_signature', 'signatured_date', 'clp_cdl_applicant_holder', 'usdot_fmcsa_medical_certificate', 'surgery_history', 'surgery_explanation', 'taking_medications', 'taking_medication_explanation', 'head_brain_injuries', 'seizures_epilepsy', 'eye_problems', 'ear_hearing_problems', 'heart_disease', 'pacemaker_stents_implantable_devices', 'high_blood_pressure', 'high_cholesterol', 'chronic_breathing_problems', 'lung_disease', 'kidney_problems', 'digestive_problems', 'diabetes_insulin', 'mental_problems', 'fainting_passing_out', 'dizziness_headaches', 'unexplained_weight_loss', 'stroke_paralysis_weakness', 'missing_limited_use_of_limbs', 'neck_back_problems', 'bone_muscle_joint_nerve_problems', 'blood_clots_bleeding', 'cancer', 'chronic_infection', 'sleep_disorders', 'had_sleep_test', 'hospital_stay', 'had_broken_bone', 'tobacco_use', 'alcohol_use', 'illegal_substance_use', 'drug_test_failure', 'other_conditions', 'other_conditions_description', 'additional_comments_description'];
            const screeningFields = ['sitting_systolic', 'sitting_diastolic', 'second_reading_systolic', 'second_reading_diastolic', 'pulse_rate', 'pulse_rhythm_regular', 'height_feet', 'weight_pounds', 'sp_gr', 'protein', 'blood', 'sugar', 'wearing_corrective_lenses', 'uncorrected_left_eye', 'uncorrected_right_eye', 'uncorrected_both_eyes', 'corrected_left_eye', 'corrected_right_eye', 'corrected_both_eyes', 'horizontal_field_of_vision_left_eye', 'horizontal_field_of_vision_right_eye', 'applicant_recognize_traffic_control_signals', 'monocular_vision', 'referred_to_ophthalmologist', 'received_documentation_from_ophthalmologist', 'check_hearing_aid_used', 'whisper_test_results_right_ear', 'whisper_test_results_left_ear'];
            const sectionOrder = [...historyFields, ...screeningFields];
            errorKeys = errorKeys.sort((a, b) => {
                const ai = sectionOrder.indexOf(a);
                const bi = sectionOrder.indexOf(b);
                if (ai === -1 && bi === -1) return 0;
                if (ai === -1) return 1;
                if (bi === -1) return -1;
                return ai - bi;
            });

            let firstErrorField = null;
            let fieldKey = null;

            for (const key of errorKeys) {
                // Try multiple possible selectors
                const selectors = [
                    `#${key}`, // Direct ID
                    `input[name="${key}"]`, // Input by name
                    `select[name="${key}"]`, // Select by name
                    `textarea[name="${key}"]`, // Textarea by name
                    `[id="${key}"]`, // Any element with ID
                    // For signature fields, they might be in a canvas or special container
                    `[data-field-name="${key}"]`,
                    // For date fields with custom components
                    `input[id*="${key}"]`,
                ];

                for (const selector of selectors) {
                    try {
                        const element = document.querySelector(selector);
                        if (element) {
                            firstErrorField = element;
                            fieldKey = key;
                            break;
                        }
                    } catch (e) {
                        // Invalid selector, continue
                    }
                }
                if (firstErrorField) break;
            }

            if (firstErrorField) {
                // Check if field is in a tab
                const tabPane = firstErrorField.closest('.tab-pane');
                if (tabPane && !tabPane.classList.contains('active')) {
                    const tabId = tabPane.id;
                    const tabLink = document.querySelector(`a[href="#${tabId}"], a[data-bs-target="#${tabId}"]`);
                    if (tabLink) {
                        // Use Bootstrap's tab API if available, otherwise click
                        const Bootstrap = window.bootstrap;
                        if (Bootstrap && Bootstrap.Tab) {
                            const tab = new Bootstrap.Tab(tabLink);
                            tab.show();
                        } else {
                            tabLink.click();
                        }
                        // Wait for tab to switch
                        setTimeout(() => {
                            // Re-find the element after tab switch
                            const element = this.findFieldElement(fieldKey);
                            if (element) {
                                this.scrollAndFocusField(element);
                            }
                        }, 200);
                        return;
                    }
                }

                // Check if field is in a collapsed section
                const collapseElement = firstErrorField.closest('.collapse');
                if (collapseElement && !collapseElement.classList.contains('show')) {
                    const collapseId = collapseElement.id;
                    const accordionToggle = document.querySelector(`a[href="#${collapseId}"], button[data-bs-target="#${collapseId}"], a[data-bs-target="#${collapseId}"]`);
                    if (accordionToggle) {
                        // Use Bootstrap's collapse API if available
                        const Bootstrap = window.bootstrap;
                        if (Bootstrap && Bootstrap.Collapse) {
                            const collapse = new Bootstrap.Collapse(collapseElement, { toggle: false });
                            collapse.show();
                        } else {
                            accordionToggle.click();
                        }
                        // Wait for section to expand
                        setTimeout(() => {
                            // Re-find the element after section expands
                            const element = this.findFieldElement(fieldKey);
                            if (element) {
                                this.scrollAndFocusField(element);
                            }
                        }, 400);
                        return;
                    }
                }

                this.scrollAndFocusField(firstErrorField);
            }
        }, 150);
    }

    findFieldElement = (key) => {
        const selectors = [
            `#${key}`,
            `input[name="${key}"]`,
            `select[name="${key}"]`,
            `textarea[name="${key}"]`,
            `[id="${key}"]`,
            `[data-field-name="${key}"]`,
            `input[id*="${key}"]`,
        ];

        for (const selector of selectors) {
            try {
                const element = document.querySelector(selector);
                if (element) {
                    return element;
                }
            } catch (e) {
                // Invalid selector, continue
            }
        }
        return null;
    }

    scrollAndFocusField = (element) => {
        if (!element) return;

        // Find the actual input element if the element is a container
        let focusableElement = element;
        if (element.tagName !== 'INPUT' && element.tagName !== 'SELECT' && element.tagName !== 'TEXTAREA') {
            // Try to find input/select/textarea inside
            const input = element.querySelector('input, select, textarea, canvas');
            if (input) {
                focusableElement = input;
            }
        }

        // Scroll to element (scroll within modal if it's in a modal)
        const modal = element.closest('.modal');
        if (modal) {
            // Scroll within modal body
            const modalBody = modal.querySelector('.modal-body');
            if (modalBody) {
                const elementTop = focusableElement.getBoundingClientRect().top;
                const modalBodyTop = modalBody.getBoundingClientRect().top;
                const scrollPosition = modalBody.scrollTop + (elementTop - modalBodyTop) - 100; // 100px offset from top
                modalBody.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        } else {
            focusableElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        
        // Focus the element
        setTimeout(() => {
            if (focusableElement.focus && typeof focusableElement.focus === 'function') {
                try {
                    focusableElement.focus();
                    // For signature fields (canvas), we might need to click instead
                    if (focusableElement.tagName === 'CANVAS') {
                        focusableElement.click();
                    }
                } catch (e) {
                    console.warn('Could not focus element:', e);
                }
            }
        }, 100);
    }

    handleReviewAndComplete = () => {
        const { pendingValidation } = this.state;
        this.setState(
            {
                showIncompleteExamModal: false,
                incompleteExamErrorsBySection: null,
                pendingValidation: null,
                validation: pendingValidation || {},
            },
            () => {
                if (pendingValidation && Object.keys(pendingValidation).length > 0) {
                    this.focusFirstErrorField(pendingValidation);
                }
            }
        );
    };

    onSubmitHandler = async (type,isSaveAndPrint=false,isModelclose=true,isSaveAndSubmit=false,isSaveProgress=false,closeAfterSave=false)=>{
        if (isSaveProgress && !closeAfterSave) isModelclose = false;
        this.setState({validation:{},showAlert:false});
        const { chartDetails,companyDetails,employeeDetails,params,Toast,Loader,suppressPatientPostSaveLogout } = this.props;
        const companyUuid = companyDetails.company_uuid;
        const {formData} = this.state;
        const { mapping_id, activity_name,activity_type } = chartDetails;
        const { profileDetails } = this.props;
        const isCompanyEmployee = profileDetails?.employee_login; 
        // Only send signoff_user_id when user has successfully signed (PIN verified → signature set; DOT uses medical_examiner_signature_two, others use provider_signature)
        const hasSigned = !!(formData?.provider_signature ?? formData?.medical_examiner_signature_two);
        // Helper function to check if value is serializable
        const isSerializable = (value) => {
            if (value === null || value === undefined) return false;
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return true;
            if (value instanceof File || value instanceof Blob) return false;
            if (value instanceof Date) return true;
            if (Array.isArray(value)) {
                return value.every(item => isSerializable(item));
            }
            if (typeof value === 'object') {
                // Check if it's a plain object (not a DOM element or React element)
                if (value.constructor && value.constructor.name !== 'Object' && value.constructor.name !== 'Array') {
                    return false;
                }
                try {
                    JSON.stringify(value);
                    return true;
                } catch (e) {
                    return false;
                }
            }
            return false;
        };

        // Helper function to clean payload data - remove non-serializable values
        const cleanPayloadData = (data) => {
            const cleaned = {};
            Object.keys(data).forEach(key => {
                const value = data[key];
                // Skip File objects, they'll be handled separately
                if (value instanceof File || value instanceof Blob) {
                    return;
                }
                // Skip null/undefined
                if (value === null || value === undefined) {
                    return;
                }
                // Include primitive values
                if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                    cleaned[key] = value;
                    return;
                }
                // Handle Date objects
                if (value instanceof Date) {
                    cleaned[key] = value.toISOString();
                    return;
                }
                // Try to serialize objects/arrays
                if (isSerializable(value)) {
                    cleaned[key] = value;
                }
            });
            return cleaned;
        };

        // Check if ekg_attachment is a File object
        const hasFile = formData.ekg_attachment instanceof File;
        const fileToUpload = hasFile ? formData.ekg_attachment : null;
        
        // Create base payload data
        const basePayloadData = {
            patient_id:employeeDetails.employee_id, //patient id mismatch issue fix change lab
            status:isSet(formData.status,"Not Started"),
            company_id:companyUuid,
            organization_uuid:OrganizationService.getOrgId(),
            visit_id:params.visitId?params.visitId:formData.visit_id,
            activity_name:activity_name,
            activity_type:activity_type,
            patient_created:isCompanyEmployee,
            signoff_user_id: hasSigned ? (AuthService.getProfileId() ?? null) : null,
            provider_signature: formData.provider_signature ?? null,
            medical_examiner_signature_two: formData.medical_examiner_signature_two ?? null,
            ...(isSaveProgress && { validation_required: false }),
        };
        if (!isSaveProgress) Loader(true);

        // Merge with formData (excluding file)
        const formDataWithoutFile = { ...formData };
        if (hasFile) {
            delete formDataWithoutFile.ekg_attachment;
        } else if (formDataWithoutFile.ekg_attachment) {
            // If ekg_attachment is an object (from backend), extract only file_id
            const ekgAttachment = formDataWithoutFile.ekg_attachment;
            if (typeof ekgAttachment === 'object' && ekgAttachment !== null && ekgAttachment.file_id) {
                formDataWithoutFile.ekg_attachment = ekgAttachment.file_id;
            } else if (typeof ekgAttachment === 'string' && ekgAttachment.trim().startsWith('{')) {
                // If it's a JSON string, try to parse and extract file_id
                try {
                    const parsed = JSON.parse(ekgAttachment);
                    if (parsed && parsed.file_id) {
                        formDataWithoutFile.ekg_attachment = parsed.file_id;
                    }
                } catch (e) {
                    // If parsing fails, keep as is (might already be a file_id)
                }
            }
        }
        // Clean and merge all data
        const cleanedFormData = cleanPayloadData(formDataWithoutFile);
        const payloadData = { ...basePayloadData, ...cleanedFormData };
        // If there's a file, create FormData, otherwise use regular payload
        let payload;
        if (hasFile && fileToUpload) {
            payload = new FormData();
            // Append all fields to FormData
            Object.keys(payloadData).forEach(key => {
                const value = payloadData[key];
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
                        // Stringify objects
                        try {
                            payload.append(key, JSON.stringify(value));
                        } catch (e) {
                            console.warn(`Could not stringify ${key}:`, e);
                        }
                    } else if (Array.isArray(value)) {
                        // Stringify arrays
                        try {
                            payload.append(key, JSON.stringify(value));
                        } catch (e) {
                            console.warn(`Could not stringify ${key}:`, e);
                        }
                    } else {
                        // Append primitive values
                        payload.append(key, value);
                    }
                }
            });
            // Append the file
            payload.append('ekg_attachment', fileToUpload);
        } else {
            payload = payloadData;
        }

        try{
            let data = {};
            if(isSet(payloadData.id,null)===null){
                 data = await PatientChartsService.savePatientCharts(isSet(formData.organization,null),companyUuid,mapping_id,payload);
            }else{
                 data = await PatientChartsService.updatePatientCharts(isSet(formData.organization,null),companyUuid,mapping_id,payload);
            }
            if (!isSaveProgress) Loader(false);
            let updateValidation = {...this.state.validation};
            if(data.status && data.status==="ERROR"){
                const errorsBySection = data.data?.errors_by_section;
                const flatErrors = data.data?.errors != null ? data.data.errors : data.data;
                if (isObject(flatErrors)) {
                  let errorMessages = [];
                  for (let key in flatErrors) {
                    if (key !== 'existing_records' && key !== 'errors_by_section') {
                      const errorMsg = Array.isArray(flatErrors[key]) 
                        ? flatErrors[key].join(". ") 
                        : flatErrors[key];
                      updateValidation = {
                        ...updateValidation,
                        [key]: errorMsg,
                      };
                      errorMessages.push(...(Array.isArray(flatErrors[key]) ? flatErrors[key] : [flatErrors[key]]));
                    }
                  }
                  // If we have existing records, add info about them
                  if (flatErrors.existing_records && isObject(flatErrors.existing_records)) {
                    const recordCounts = Object.keys(flatErrors.existing_records).length;
                    if (recordCounts > 0) {
                      errorMessages.push(`Found ${recordCounts} duplicate lab order(s) in database.`);
                    }
                  }
                  // Show each validation error as a separate toast (skip if showing section modal)
                  const hasSectionErrors = errorsBySection && Object.keys(errorsBySection).length > 0;
                  if (errorMessages.length > 0 && !hasSectionErrors) {
                    const firstError = errorMessages
                      .map((msg) => (msg == null ? "" : String(msg).trim()))
                      .find(Boolean);

                    if (firstError) {
                      Toast.error(firstError);
                    }
                  }
                } else if (!errorsBySection) {
                  Toast.error(data.data);
                }
                if (Object.keys(updateValidation).length > 0) {
                  if (errorsBySection && Object.keys(errorsBySection).length > 0) {
                    this.setState({
                      showIncompleteExamModal: true,
                      incompleteExamErrorsBySection: errorsBySection,
                      pendingValidation: updateValidation,
                    });
                  } else {
                    this.setState({validation:updateValidation}, () => {
                      this.focusFirstErrorField(updateValidation);
                    });
                  }
                }
              }else{
                 if(isCompanyEmployee==true && !suppressPatientPostSaveLogout){
                    //  const profileId = AuthService.getProfileId();
                    //  this.props.removeProfile(profileId);
                    //  this.props.resetGlobalFilter();
                    //  this.props.resetDD();
                    //  Toast.success('Charts Updated Successfully');
                    //  Toast.success(profileDetails.name + ' logged-out successfully');
                     if (!isSaveProgress) Loader(false);
                     await AuthService.logout();
                     this.props.navigate(`/formcompleted`);
                 }
                if(isSaveAndSubmit){
                  if (data && typeof data === 'object' && !(data.status === 'ERROR')) {
                    this.setState((prev) => ({ formData: { ...prev.formData, ...data } }));
                  }
                  this.props.fetchVisitDetails();
                  return { success: true };
                }
                if(isSaveAndPrint===true){
                    this.printResultHandler(type,isSaveAndPrint);
                }
                /** Refetch / signal parent: full save always; save-progress only when closing (e.g. patient questionnaire → advance step). */
                if (!isSaveProgress || closeAfterSave) {
                    this.props.fetchVisitDetails?.();
                }
                if (isModelclose==true) {
                    this.props.toogleHanlder();
                }
                if (data && typeof data === 'object' && !(data.status === 'ERROR')) {
                    this.setState((prev) => ({ formData: { ...prev.formData, ...data } }));
                }
                Toast.success(isSaveProgress ? 'Progress saved' : 'Charts Updated Successfully');
              }

            
        }catch(e){
            if (!isSaveProgress) Loader(false);
            Toast.error('Something went wrong! Please try again later.');
        }
        
    }

    fetchPatientChartDetials =async  ()=>{
        const { chartDetails,companyDetails,Loader } = this.props;
        const companyUuid = companyDetails.company_uuid;
        const { mapping_id } = chartDetails;
        Loader(true);
        try{
            let data = await PatientChartsService.getPatientChart(companyUuid,mapping_id);
            Loader(false);
            data=isArray(data)?data.length==0?null:data:data; //array empty handle for respiratory fit test issue
            if(isSet(data,null)!==null){
                // DME stores signature/signature_date; ProviderSignOff expects provider_signature and signed_date
                if (chartDetails?.activity_type === 'DME') {
                    if (data?.signature) data = { ...data, provider_signature: data.signature };
                    if (data?.signature_date) data = { ...data, signed_date: data.signature_date };
                }
                this.setFormData({...isSet(data,{}),suggested_status:isSet(data,{status:''}).status});
                // this.setState({status:200});
            }else{
                this.setState({status:200});
            }
            
        }catch(e){
            Loader(false);
        }
    }
}
// map Redux state to props
const mapStateToProps = (state) => ({
    profileDetails: activeProfileDetails(state), // <-- this will be available in this.props.profileDetails
  });
const mapDispatchToProps = (dispatch) => ({
//   removeProfile: (id) => dispatch(removeProfileAsync(id)),
//   resetGlobalFilter: () => dispatch(resetGlobalFilter()),
//   resetDD: () => dispatch(resetDD()),
});  
  
  // export wrapped version
  export default connect(mapStateToProps,mapDispatchToProps)(
    withReduxState(WithRoutify(ActivityCharts))
  );
  
